import { Decorator } from '../../Enum/Filters';
import { FilterState } from '../../Store/Filter/state';
import InterestUri from '../../Enum/InterestUri';
import { RootState } from '../../Store';
import { Sort } from '../../Interface/Table/Sort';

import { useSelector } from 'react-redux';

const useGetSort = (section: InterestUri): Sort => {
    const { decoratorValues } = useSelector<RootState, FilterState>(state => state.filter);
    return decoratorValues[Decorator.Sorting][section];
};

export default useGetSort;
